import API from '@/views/Fdc/Apis/'
import _ from 'lodash'

/**
 * 기준 정보 Copy Modal Component
 * 기준 정보를 Copy하는 Modal Component
 */
export default {
  name: 'EqpCopyModal',
  props: {
    /**
     * Modal 표시 여부
     * @param {Boolean} eqpCopyModalVisible
     */
    eqpCopyModalVisible: {
      type: Boolean,
      default: false
    },
    /**
     * From 장비 정보
     * @param {Object} fromEqp
     * from eqp tree에 data를 setting할 때 사용합니다.
     */
    fromEqp: {
      type: Object,
      default: null
    },
    /**
     * Copy Modal Type
     * @param {String} copyModalType
     * EQP to EQP로 Copy하는지 Module to Module로 Copy하는지 여부를 판단하기 위해 사용합니다.
     */
    copyModalType: {
      type: String,
      default: 'eqp'
    }
  },
  watch: {
    /**
     * Modal 표시 여부 감지
     * @param {Boolean} value Modal 표시 여부
     * Modal 표시 여부를 결정하고, Copy Modal Type 값에 따라 신규 EQP를 추가 여부 data를 변경하여 줍니다.
     */
    eqpCopyModalVisible (value) {
      this.modalVisible = this.eqpCopyModalVisible
      if (value && this.copyModalType !== 'eqp') {
        this.newEqpAdd = false
      }
    }
  },
  methods: {
    /**
     * From EQP 선택 시 실행되는 method
     * @param {Object} node From EQP tree node data
     */
    modalFromTreeSelected (node) {
      this.fromTreenode = node
    },
    /**
     * To EQP 선택 시 실행되는 method
     * @param {Object} node To EQP tree node data
     */
    modalToTreeSelected (node) {
      this.toTreenode = node
    },
    /**
     * 기준 정보 Copy
     */
    async eqpCopy () {
      let self = this
      let matchRowData = []
      if (this.matchRowData.length > 0) {
        for (let i = 0; i < this.matchRowData.length; i++) {
          var data = _.clone(this.matchRowData[i])
          delete data['_status']
          matchRowData.push(data)
        }
      }
      let params = {
        eqpInfoEvent: this.eqpInfoEvent,
        eqpInfoParam: this.eqpInfoParam,
        eqpInfoRecipe: this.eqpInfoRecipe,
        dcpEvent: this.dcpEvent,
        dcpTrace: this.dcpTrace,
        dcpContext: this.dcpContext,
        // fdmUva: this.fdmUva,
        fdmUvaSetPoint: this.fdmUvaSetPoint,
        fdmUvaFormula: this.fdmUvaFormula,
        fdmMva: this.fdmMva,
        newEqpAdd: this.newEqpAdd,
        fromTreenode: this.fromTreenode.detail,
        toTreenode: this.toTreenode.detail,
        newEqpAddEqpId: this.newEqpAddEqpId,
        newEqpAddEqpName: this.newEqpAddEqpName,
        matchRowData: matchRowData
      }

      if (!this.copyValidation(params)) {
        return
      }

      if (!this.matchingVisible &&
          params.fromTreenode.moduleId === '' && params.toTreenode.moduleId === '' &&
          params.toTreenode.eqpId !== '') {
        this.$dialog.alert(this.$t('fdc.EQP_INFO.MESSAGE.INFORM_MATCH_EQP'))
        this.showMatching()
        return
      }

      let message = ''
      let matchedMessage = ''

      if (!this.newEqpAdd) {
        let eqpInfoObj = await API.BaseInfo.getEqpCount(params)
        if (eqpInfoObj === undefined) return
        // let keys = Object.keys(eqpInfoObj)
        // console.log('keys', keys)
        let matchedMessageAdd = true

        Object.entries(eqpInfoObj).forEach(([key, value], index) => {
          if (key !== 'fab' && key !== 'eqpId' && key !== 'moduleId') {
            if (value.count > 0) {
              if (matchedMessageAdd) {
                matchedMessage = '<br>' + this.$t('fdc.EQP_INFO.MESSAGE.INFORM_EXIST_EQP_INFO') + '<br>'
              }

              message += '<p class="copy-info-text"><label class="copy-info-label">'

              if (key === 'eqpEvent') message += 'EQP Event</label>'
              else if (key === 'eqpParameter') message += 'EQP Parameter</label>'
              else if (key === 'eqpRecipe') message += 'EQP Recipe</label>'
              else if (key === 'eqpRecipeStep') message += 'EQP Step</label>'
              else if (key === 'dcPlan') message += 'Data Collection Plan</label>'
              else if (key === 'dcPlanEvent') message += 'Event Collection Plan</label>'
              else if (key === 'dcPlanTrace') message += 'Trace Collection Plan</label>'
              else if (key === 'dcPlanContext') message += 'Context Mappling Plan</label>'
              else if (key === 'uvaSetPoint') message += 'Set-Point Model</label>'
              else if (key === 'uvaFormula') message += 'Formula Model</label>'
              else if (key === 'mva') message += 'Multivariate Model</label>'
              else if (key === 'fdModelCond') message += 'Detection Model Condition</label>'

              message += '<label class="copy-info-sublabel">Total : ' + value.count + '</label>'
              message += '<label class="copy-info-sublabel">Match : ' + value.matchCount + '</label>'
              message += '<label class="copy-info-sublabel">Mismatch : ' + value.misMatchCount + '</label>' + '</p>'

              matchedMessageAdd = false
            }
          }
        })

        // if (eqpInfoCnt === undefined) return
        // if (Number(eqpInfoCnt) > 0) message += this.$t('fdc.EQP_INFO.MESSAGE.INFORM_EXIST_EQP_INFO')
      }

      if (matchedMessage !== '') {
        message += matchedMessage
      }

      message += this.$t('fdc.EQP_INFO.MESSAGE.CONFIRM_COPY')
      for (let i = 0; i < this.matchRowData.length; i++) {
        if (this.matchRowData[i].toModuleId === null || this.matchRowData[i].toModuleId === undefined) {
          message += this.$t('fdc.EQP_INFO.MESSAGE.INFORM_NOT_COPY_ITEM')
          break
        }
      }

      this.$dialog.confirm({
        title: 'To EQP Info Status',
        message: message,
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: function () {
          function copyLastProcess (response) {
            if (response != null && response.status === 200) {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.SUCCEED_COPY'))
              self.modalVisible = false
              self.resetCopyModalData()
              self.matchingVisible = false
              self.resetMatchModalData()
            } else {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_COPY'))
            }
          }
          API.BaseInfo.runEqpCopy(params).then(result => {
            copyLastProcess(result)
          })
        },
        onCancel: function () {}
      })
    },
    /**
     * 기준 정보 Copy Validation
     * @param {Object} params copy data 배열
     * @returns {Boolean} validation 성공 여부
     */
    copyValidation (params) {
      if (!params.eqpInfoEvent && !params.eqpInfoParam && !params.eqpInfoRecipe && !params.dcpEvent && !params.dcpTrace &&
        // !params.dcpContext && !params.fdmUva && !params.fdmMva && !params.newEqpAdd) {
        !params.dcpContext && !params.fdmUvaSetPoint && !params.fdmUvaFormula && !params.fdmMva && !params.newEqpAdd) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Copy Item']))
        return false
      } else if (!params.fromTreenode) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['"From Equipment"']))
        return false
      } else if (params.fromTreenode.eqpId === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['"From Equipment"']))
        return false
      } else if (!params.toTreenode) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['"To Equipment"']))
        return false
      } else if (!params.newEqpAdd &&
        params.fromTreenode.eqpId !== '' && params.fromTreenode.moduleId === '' &&
        params.toTreenode.eqpId === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['EQP ID of "To Equipment"']))
        return false
      } else if (!params.newEqpAdd &&
        params.fromTreenode.eqpId !== '' && params.fromTreenode.moduleId !== '' &&
        params.toTreenode.moduleId === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Module ID of "To Equipment"']))
        return false
      } else if (params.newEqpAdd && params.toTreenode.eqpModel === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['EQP Model of "To Equipment"']))
        return false
      } else if (this.copyModalType === 'eqp' && params.newEqpAdd && (params.newEqpAddEqpId === null || params.newEqpAddEqpId.trim() === '')) {
        this.$refs.newEqpAddEqpId.focus()
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['EQP ID']))
        return false
      } else if (this.copyModalType === 'eqp' && params.newEqpAdd && (params.newEqpAddEqpName === null || params.newEqpAddEqpName.trim() === '')) {
        this.$refs.newEqpAddEqpName.focus()
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['EQP Name']))
        return false
      }
      return true
    },
    /**
     * Data 초기화
     * Modal에 설정된 data를 초기화 하고, Modal이 포함된 상위 페이지에 Modal 표시 여부를 false로 변경합니다.
     */
    resetCopyModalData () {
      this.$emit('eqp-copy-modal-visible', false)
      this.fromTreeType = 'eqp'
      this.toTreeType = 'eqp'
      this.eqpInfoEvent = true
      this.eqpInfoParam = true
      this.eqpInfoRecipe = true
      this.dcpEvent = true
      this.dcpTrace = true
      this.dcpContext = true
      // this.fdmUva = true
      this.fdmUvaSetPoint = true
      this.fdmUvaFormula = true
      this.fdmMva = true
      this.fromTreenode = []
      this.toTreenode = []
      this.newEqpAdd = true
      this.newEqpAddEqpId = null
      this.newEqpAddEqpName = null
    },
    /**
     * Module Matching Modal 열기
     * From 장비(EQP)의 Module과 To 장비(EQP)의 Module을 1대1 matching하는 Modal을 열어줍니다.
     */
    showMatching () {
      this.matchRowData = []
      this.getEqpModuleList(this.fromTreenode.detail.fab, this.fromTreenode.detail.eqpId).then((result) => {
        let rowData = []
        for (let i = 0; i < result.length; i++) {
          let obj = {
            fromFab: result[i].fab,
            fromEqpId: result[i].eqpId,
            fromModuleId: result[i].moduleId,
            toFab: this.toTreenode.detail.fab,
            toEqpId: this.toTreenode.detail.eqpId,
            toModuleId: null
          }
          rowData.push(obj)
        }
        this.matchRowData = rowData
      })
      this.getEqpModuleList(this.toTreenode.detail.fab, this.toTreenode.detail.eqpId).then((result) => {
        // let col = this.moduleMatchGrid.columns.getColumn('toModuleId')
        // let dataMap = []
        // for (let i = 0; i < result.length; i++) {
        //   let obj = {
        //     toModuleId: result[i].moduleId
        //   }
        //   dataMap.push(obj)
        // }
        // if (col) {
        //   col.dataMapEditor = true
        //   col.dataMap = this.buildDataMap(dataMap, 'toModuleId')
        // }

        let dataMap = []
        for (let i = 0; i < result.length; i++) {
          dataMap.push(result[i].moduleId)
        }
        this.updateComboBoxInGrid(dataMap)
      })
      this.matchingVisible = true
    },
    updateComboBoxInGrid (dataMap) {
      this.matchColumns.map(c => {
        if (c.field === 'toModuleId') {
          c.cellEditor = 'agSelectCellEditor'
          c.cellEditorParams = {
            values: dataMap
          }
        }
        return c
      })
      this.$refs.moduleMatchGrid.gridApi.setColumnDefs(this.matchColumns)
    },
    /**
     * Module Matching data 초기화
     */
    resetMatchModalData () {
      this.matchRowData = []
      this.matchingVisible = false
    },
    /**
     * Module 목록 조회
     * @param {String} fab Fab
     * @param {String} eqpId EQP ID
     * @returns {Array} Module 배열
     */
    async getEqpModuleList (fab, eqpId) {
      let payload = {
        fab: fab,
        eqpId: eqpId
      }
      let data = await API.BaseInfo.getEqpModules(payload)
      return data
    }
  },
  data () {
    return {
      modalVisible: false, // Modal 표시 여부
      fromTreeType: 'eqp', // From EQP Tree Type
      toTreeType: 'eqp', // To EQP Tree Type
      eqpInfoEvent: true, // Event Copy 여부
      eqpInfoParam: true, // Parameter Copy 여부
      eqpInfoRecipe: true, // Recipe/Step Copy 여부
      dcpEvent: true, // Event Collection Plan Copy 여부
      dcpTrace: true, // Trace Collection Plan Copy 여부
      dcpContext: true, // Context Mapping Plan Copy 여부
      dcpDisabled: false, // Data Collection Plan의 data Copy를 disable할지 여부 - Module to Module Copy에서는 disabled 해야 함.
      // fdmUva: true,
      fdmUvaSetPoint: true, // Set-Point Detection Model Copy 여부
      fdmUvaFormula: true, // Formula Detection Model Copy 여부
      fdmMva: true, // Multivariate Detection Model Copy 여부
      fromTreenode: [], // From EQP Tree에서 선택된 node 배열
      toTreenode: [], // To EQP Tree에서 선택된 node 배열
      newEqpAdd: true, // 신규 EQP 등록 여부
      newEqpAddDisabled: false, // 신규 EQP 등록 가능 여부
      newEqpAddEqpId: null, // 신규 EQP ID data
      newEqpAddEqpName: null, // 신규 EQP Name data
      // fromTreeObj: null,
      matchingVisible: false, // Module Matching Modal 표시 여부
      matchColumns: [
        // { binding: 'fromFab', visible: false },
        // { binding: 'fromEqpId', visible: false },
        // { label: this.$t('fdc.EQP_INFO.COLUMN.FROM_MODULE_ID'), binding: 'fromModuleId', width: 150, readOnly: true },
        // { binding: 'toFab', visible: false },
        // { binding: 'toEqpId', visible: false },
        // { label: this.$t('fdc.EQP_INFO.COLUMN.TO_MODULE_ID'), binding: 'toModuleId', width: 150, required: true, dataMap: [] }

        { field: 'fromFab', hide: true },
        { field: 'fromEqpId', hide: true },
        { headerName: this.$t('fdc.EQP_INFO.COLUMN.FROM_MODULE_ID'), field: 'fromModuleId', flex: 1, editable: false },
        { field: 'toFab', hide: true },
        { field: 'toEqpId', hide: true },
        { headerName: this.$t('fdc.EQP_INFO.COLUMN.TO_MODULE_ID'), field: 'toModuleId', flex: 1, required: true, editable: true }
      ], // Module Match Grid column 배열
      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      matchRowData: [] // Module Matching된 결과에 해당하는 row data 배열
    }
  }
}
